module.exports = __webpack_public_path__ + "static/media/placeholder.0c9ac882.jpg";